// extracted by mini-css-extract-plugin
export var CTAContainer = "CTANews-module--CTAContainer--39GiX";
export var Left = "CTANews-module--Left--1QYJT";
export var Right = "CTANews-module--Right--2OZE4";
export var CardContainer = "CTANews-module--CardContainer--1btlJ";
export var NewsCard = "CTANews-module--NewsCard--DIzHq";
export var ImageContainer = "CTANews-module--ImageContainer--28WnI";
export var Image = "CTANews-module--Image--2d6D4";
export var Date = "CTANews-module--Date--1JdWR";
export var Excerpt = "CTANews-module--Excerpt--2mkyW";